class Monitoring.Models.SocialContentModerator

  constructor: (@socialContentViews, @params={}) ->

  moderate: (review=false, callback=null, searchAction='moderate') ->
    @action = searchAction
    @_doPost({moderations: @getModerations(), review: review}, callback)

  delete: ->
    @action = 'delete'
    @_doPost({ social_contents: _.map(@socialContentViews, (view) -> view.model.get('id')) })

  _doPost: (data, callback) ->
    callback ||= ->
    document.body.style.cursor = 'wait'
    $.ajax
      url: "/monitoring/dashboard/#{@action}.json/"
      type: 'POST'
      data: $.extend({}, data, @params)
      success: (response) =>
        @onSuccess(response)
        callback()
      error: @onError
      dataType: 'json'
      complete: -> document.body.style.cursor = 'default'

  getModerations: ->
    _.map(@socialContentViews, (view) =>
      data = { id: view.model.get('id'), tags: @_normalizeList(view.getActiveTags()), labels: @_normalizeList(view.getLabels()), sentiment: view.getSentiment() }
      if view.model.get('review_mode')
        if view.shouldBeEscalated()
          data.review_status = 'ESCALATED'
          data.moderation_comment = view.model.get('moderation_comment')
        else if view.model.get('review_status') == 'ESCALATED'
          data.review_status = 'REVIEWED_BY_SUPERVISOR'
      data
    )

  _normalizeList: (list) ->
    if list.length > 0 then list else 'EMPTY'

  onSuccess: (response) =>
    _.each response.success, (socialContent) =>
      view = _.find(@socialContentViews, (view) => socialContent.id == view.model.get('id'))
      view.onModerationSuccess(socialContent)
      view.onDeleteSuccess(socialContent) if @action == 'delete'

    _.each response.failed, (socialContent) =>
      view = _.find(@socialContentViews, (view) => socialContent.id == view.model.get('id'))
      view.onModerationError(socialContent)

  onError: =>
    _.each @socialContentViews, (view) ->
      view.onModerationError({ errors: "An unexpected error has occurred. Please contact us if this error persists."})